import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  Tooltip,
  ResponsiveContainer,
  PolarRadiusAxis,
} from "recharts";

function RadarGraph(props) {
  // Check if custom dimemsions are non-zero
  // const customDim = [];
  // props.data.map((dim,index)=>(
  //   customDim.push(dim.Custom)
  // ));

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white bg-opacity-90 border-gray-200 border-2  px-5 py-3 rounded-sm">
          <div className="flex items-center gap-x-2 mt-auto text-xs">
            <p className="font-bold">{payload[0].payload.subject}</p>
            <p className="text-[#8884d8]">{payload[0].payload.Reference}</p>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="flex-inline lg:-mr-0">
      <div className="w-full">
        <ResponsiveContainer width="100%" height={220}>
          <RadarChart
            cx="45%"
            cy="50%"
            outerRadius="60%"
            height="100%"
            data={props.data}
            margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
          >
            <PolarGrid
              gridType="circle"
              polarRadius={[0, props.polarRadius ? props.polarRadius : "30%"]}
              style={{
                stroke: "#bdbfbf",
                strokeWidth: 0.403,
                fill: "#FFFFFF",
                fillOpacity: 0.5,
              }}
            />
            <PolarAngleAxis
              dataKey="subject"
              fontSize={props.labelFontSize ? props.labelFontSize : 16}
              // style = {{ 'stroke':"#e31c79", 'width': 1,}}
            />
            <PolarRadiusAxis
              angle={30}
              domain={[0, 100]}
              style={{ opacity: 0 }}
            />

            {props.refShow && (
              <Radar
                name={props ? props.refShowName : "Reference"}
                dataKey="Reference"
                stroke={props.color}
                strokeWidth={0.5}
                fill={props.color}
                fillOpacity={0.4}
              />
            )}

            <Tooltip
              content={<CustomTooltip payload={props.data} />}
              position={props.showName.length >= 30 && { x: -150 }}
              //  allowEscapeViewBox={{ x: false, y: true }}
              // position={{ x: -150 }}
              //  viewBox={{ x: -100, y: 0, width: 400, height: 400 }}
            />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default RadarGraph;
